import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden" }
const _hoisted_2 = {
  class: "grid justify-content-center p-2 lg:p-0",
  style: {"min-width":"80%"}
}
const _hoisted_3 = {
  class: "col-12 xl:col-5",
  style: {"border-radius":"56px","padding":"0.3rem","background":"linear-gradient(180deg, var(--primary-color), rgba(33, 150, 243, 0) 30%)"}
}
const _hoisted_4 = {
  class: "h-full w-full m-0 py-7 px-4",
  style: {"border-radius":"53px","background":"linear-gradient(180deg, var(--surface-50) 38.9%, var(--surface-0))"}
}
const _hoisted_5 = { class: "text-center mb-5" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "w-full md:w-10 mx-auto" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "userId",
  class: "block text-900 text-xl font-medium mb-2"
}, "ID", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "userPassword",
  class: "block text-900 font-medium text-xl mb-2"
}, "Password", -1)


import axios from "axios";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

const __default__ = {
  data() {
    return {
      adminUser: {
        admId : "",
        admPwd: ""
      }
    };
  },
  methods: {
    login    : function() {
      const _this = this;
      axios.post("/api/auth/login", this.adminUser, window.axiosOptions).then(function(response) {
        if (response.data.success === 200) {
          cookies.set("Authentication", response.data.resp.accessToken, 60 * 20)
          cookies.set("Refresh", response.data.resp.refreshToken, 60 * 60 * 24)
          _this.$router.push({ name: "Admin" });
        } else {
          _this.showToast("error", "서버 접속 실패", "서버에 접속할 수 없습니다.");
        }
      }).catch(function(err) {
        console.error(err);
        _this.showToast("error", "로그인 실패", "아이디 또는 비밀번호를 틀립니다.");
      });
    },
    showToast: function(toastType, message, description) {
      this.$toast.add({ severity: toastType, summary: message, detail: description, life: 3500 });
    }
  }
};
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "prismjs/themes/prism-coy.css";
import logo_l from "@/assets/images/logo_l_transparent.png";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {


return (_ctx, _cache) => {
  const _component_Toast = _resolveComponent("Toast")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Password = _resolveComponent("Password")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toast, { position: "top-center" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _unref(logo_l),
              alt: "Logo",
              height: "55",
              class: "mb-3"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputText, {
              id: "userId",
              modelValue: _ctx.adminUser.admId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.adminUser.admId) = $event)),
              type: "text",
              class: "w-full mb-3",
              placeholder: "ID",
              style: {"padding":"1rem"}
            }, null, 8, ["modelValue"]),
            _hoisted_9,
            _createVNode(_component_Password, {
              id: "userPassword",
              class: "w-full mb-3 pb-1",
              inputClass: "w-full",
              inputStyle: "padding:1rem",
              modelValue: _ctx.adminUser.admPwd,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.adminUser.admPwd) = $event)),
              toggleMask: true,
              feedback: false,
              placeholder: "Password",
              onKeyup: _withKeys(_ctx.login, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]),
            _createVNode(_component_Button, {
              label: "로그인",
              class: "p-button-secondary w-full p-3 text-xl",
              onClick: _ctx.login
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ])
  ]))
}
}

})